import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';

@Component({
    selector: 'app-radio-button-form',
    templateUrl: './radio-button-form.component.html',
    standalone: false
})
export class OrderRadioButtonFormComponent implements OnInit {

  field: OrderFieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  clearQuestions: string[] = [];
  sortedOptions: Option[];

  constructor(private broadCastService: BroadcastService, private dynamicService: DynamicFormServiceService) { }

  ngOnInit() {
    this.sortedOptions = this.sortedSequence();
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
  }

  private sortedSequence() {
    if (this.field && this.field.options) {
      return ((this.field.labelCode === 'SONOID' ||
        this.field.labelCode === 'SSUPER') ?
        this.field.options.sort((a, b) => {
          const left = a.value.toUpperCase();
          const right = b.value.toUpperCase();
          if (left < right) {
            return -1;
          }
          if (left > right) {
            return 1;
          }
          return 0;
        }) : this.field.options.sort((a, b) => a.sequence - b.sequence));
      }
  }

}
